import { createFileRoute } from "@tanstack/solid-router";
import { NavLab } from "~/components/dev/nav-lab";

// Hidden desktop-nav prototype bench, reachable only by typing /dev/nav. Not
// linked from anywhere and code-split into its own chunk, so it costs the normal
// app nothing until visited. See ~/components/dev/nav-lab for the three shells.
export const Route = createFileRoute("/dev/nav")({
  component: NavLab,
});
